import React, { useState } from "react";
import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useAdminAuth } from "../../context/AdminAuthContext";
import logo from "../../assets/logo.png";

const NAV_ITEMS = [
  { to: "/admin", label: "Dashboard", icon: "◧", end: true },
  { to: "/admin/universities", label: "Campuses", icon: "◫" },
  { to: "/admin/students", label: "Students", icon: "◨" },
  { to: "/admin/funnel", label: "Hiring funnel", icon: "◪" },
  { to: "/admin/panel-users", label: "Panel members", icon: "◔" },
  { to: "/admin/settings", label: "Settings", icon: "◩" },
];

export default function AdminLayout() {
  const [open, setOpen] = useState(false);
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate("/admin/login", { replace: true });
  }

  return (
    <div className="pm-admin">
      <aside className={`pm-sidebar ${open ? "is-open" : ""}`}>
        <Link to="/" className="pm-sidebar__brand">
          <img src={logo} alt="Positive Moves" className="pm-brand-logo pm-brand-logo--sidebar" />
          <small>Campus Console</small>
        </Link>

        <nav className="pm-sidebar__nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `pm-sidebar__link ${isActive ? "is-active" : ""}`}
              onClick={() => setOpen(false)}
            >
              <span className="pm-sidebar__icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="pm-sidebar__account">
          <div className="pm-sidebar__account-name">{admin?.name}</div>
          <button className="pm-sidebar__logout" onClick={handleLogout}>Log out</button>
        </div>

        <Link to="/" className="pm-sidebar__exit">
          ← Back to public site
        </Link>
      </aside>

      <button className="pm-sidebar__toggle" onClick={() => setOpen((v) => !v)}>
        {open ? "✕" : "☰"}
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            className="pm-sidebar__scrim"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
          />
        )}
      </AnimatePresence>

      <main className="pm-admin__main">
        <Outlet />
      </main>
    </div>
  );
}